import {message, notification} from 'antd';

notification.config({
    placement: 'bottomRight'
});

message.config({
    top: '90%' as any
})
